package top.wcpe.allincore.ui.runtime.ir.eval

import top.wcpe.allincore.ui.runtime.event.KeyEvent
import top.wcpe.allincore.ui.runtime.event.MouseEvent
import kotlin.jvm.JvmStatic

/**
 * DSL 事件 map：在可变 Map 之上额外把 consume/isConsumed 委托回原始 KeyEvent/MouseEvent。
 *
 * 原为 LinkedHashMap 子类；common 的 LinkedHashMap 为 final 不可继承（FR-UI-021 批F），
 * 改为接口委托——对消费方仍是保插入序的 MutableMap，仅不再是 LinkedHashMap 子类型。
 */
class EventMap(private val keyEvent: KeyEvent?, private val mouseEvent: MouseEvent?) :
    MutableMap<String, Any?> by LinkedHashMap() {

    companion object {
        @JvmStatic fun ofKey(event: KeyEvent): EventMap = EventMap(event, null)

        @JvmStatic fun ofMouse(event: MouseEvent): EventMap = EventMap(null, event)
    }

    /** 标记底层事件为已消费。 */
    fun consume() {
        keyEvent?.consume()
        mouseEvent?.consume()
    }

    /** 查询底层事件是否被消费。 */
    fun isConsumed(): Boolean {
        if (keyEvent != null) return keyEvent.isConsumed
        if (mouseEvent != null) return mouseEvent.isConsumed
        return false
    }
}
